import {
  Caption,
  useSnackbar
} from '@walmart-web/livingdesign-components';
import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { postService, getService } from "../../../../axios/axios";
import ActionPopover from "../../../../components/Table/ActionPopover/ActionPopover";
import MuiDataTable from "../../../../components/Table/MuiDataTable/MuiDataTable";
import { INVOICE_SERVICE } from "../../../../constants/baseURLs";
import { INVOICE_LINE_ITEMS_WARNING_MESSAGE, INVOICE_UPDATE_MESSAGE } from "../../../../constants/messages";
import { TableCellDisplay, amountFormat, filterPayload } from "../../../../helpers/commonUtils";
import {
  ENABLE_SERVER_SIDE_FEATURES_LINE_ITEMS,
  ROWS_PER_PAGE_LINE_ITEMS,
  ROWS_PER_PAGE_OPTIONS_LINE_ITEMS
} from "../../../../constants/tableConfigs";
import { getErrorMessage, renderTernary } from '../../../../helpers/utils';
import { useParams, useHistory } from 'react-router-dom';
import { Operations } from '../../../../axios/operations';
import { formSearchQuery, getSerialNumber } from '../../../../helpers/tableUtils';
import { displayLocalDate } from '../../../../helpers/utcUtils';
import {
  setAdjustedExpenseLineItems,
  setAdjustedFeeLineItems,
  setNonAdjustedFeeLineItems,
  setAdjustedSelectLineItems,
  setNonAdjustedSelectLineItems,
  setNonAdjustedExpenseLineItems,
  setNonAdjustedPaginationForLineItems,
  setAdjustedPaginationForLineItems
} from "../../../../store/actions/invoiceActions";
import { MOMENT_DATE_FORMAT } from '../../../../constants/dateFormats';
import { LABEL_DRAFT, LINE_ITEM_MESSAGES, LINE_ITEM_ROW_DESCRIPTIONS, STATUSES_FOR_FILTER_LINE_ITEMS_ADJUSTMENT } from '../../../../constants/constants';
import { Tooltip } from '@mui/material';
import { FeatureValueToggle } from '../../../../components/FeatureFlags/FeatureFlags';
import { FEATURES } from '../../../../constants/features';
import { CheckCircle, Warning } from '@walmart-web/livingdesign-icons';
import BuildIcon from '@mui/icons-material/Build';
import PersonIcon from '@mui/icons-material/Person';
import WarningPanel from '../../../../components/WarningPanel/WarningPanel';
import LineItemRuleResultPopOver from './LineItemRuleResultPopOver';
import InvoiceLineItemsStyles from './InvoiceLineItems.styles';

const LineItemDatatable = ({ isCurrent, invoiceStatus, isAdjusted, lineItemType, fromMatter, currentMatterTab, parentLoading = false }) => {
  const [lineItemsLoading, setLineItemsLoading] = useState(false);
  const { invoiceId } = useParams();
  const dispatch = useDispatch();
  const { addSnack } = useSnackbar();
  const history = useHistory();
  const [sortQueryAdjusted, setSortQueryAdjusted] = useState("");
  const [sortQueryNonAdjusted, setSortQueryNonAdjusted] = useState("");
  const [rowsPerPageLineItemsAdjusted, setRowsPerPageLineItemsAdjusted] = useState(ROWS_PER_PAGE_LINE_ITEMS);
  const [rowsPerPageLineItemsNonAdjusted, setRowsPerPageLineItemsNonAdjusted] = useState(ROWS_PER_PAGE_LINE_ITEMS);
  const adjustedLineItemsPaginationDetail = useSelector((state) => state?.invoice?.adjustedLineItemsPaginationDetail);
  const nonAdjustedLineItemsPaginationDetail = useSelector((state) => state?.invoice?.nonAdjustedLineItemsPaginationDetail);
  const nonAdjustedFeeLineItems = useSelector((state) => state?.invoice?.nonAdjustedFeeLineItems);
  const nonAdjustedExpenseLineItems = useSelector((state) => state?.invoice?.nonAdjustedExpenseLineItems);
  const adjustedFeeLineItems = useSelector((state) => state?.invoice?.adjustedFeeLineItems);
  const adjustedExpenseLineItems = useSelector((state) => state?.invoice?.adjustedExpenseLineItems);
  const lineItemTypeFeeExpense = lineItemType === "Fees" ? 'fee' : 'expense';
  const defaultSortQuery = "&order=lineItemDate asc"
  const isAdjustedFee = isAdjusted ? adjustedFeeLineItems : nonAdjustedFeeLineItems;
  const isNonAdjustedFee = isAdjusted ? adjustedExpenseLineItems : nonAdjustedExpenseLineItems;
  const lineItemsData = lineItemType === "Fees" ? isAdjustedFee :
  isNonAdjustedFee;
  const [selectRowsData, setSelectRowsData] = useState([]);
  const adjustedSelectLineItems =  useSelector((state) => state?.invoice?.adjustedSelectLineItems);
  const nonAdjustedSelectLineItems =  useSelector((state) => state?.invoice?.nonAdjustedSelectLineItems);
  const [isOpen, setIsOpen] = useState(false);
  const [lineItemRuleResults, setLineItemRuleResults] = useState({});
  const [alertMessage, setAlertMessage] = useState();
  const [lineItemDescription, setLineItemDescription] = useState();
  const classes = InvoiceLineItemsStyles()
  const [filters,setFilters] = useState("");

  const defaultFilterCondition = `${formSearchQuery(
    "isActive",
    Operations.EQ,
    true,
    'boolean'
  )}+${formSearchQuery(
    "invoice.id",
    Operations.EQ,
    invoiceId,
    'id'
  )}+${formSearchQuery(
    "lineItemType",
    Operations.EQ,
    lineItemTypeFeeExpense,
    'id'
  )}+${formSearchQuery(
    "isAdjusted",
    Operations.EQ,
    isAdjusted,
    'id'
  )}`;

  /*
  * on  Click of Warning symbol in line items or adjusted lien items
  */
  const warningHandle = useCallback((event, tableMeta) => {
    event.stopPropagation()
    setLineItemDescription(tableMeta?.rowData[2] !== undefined ? tableMeta?.rowData[2] : "-")
    setAlertMessage(INVOICE_LINE_ITEMS_WARNING_MESSAGE + (tableMeta?.rowIndex + 1))
    setLineItemRuleResults(tableMeta?.rowData[17] ? JSON.parse(tableMeta?.rowData[17]): {})
    setIsOpen(true)
  });

  const actionsBodyRender = (value, tableMeta, update) => {
    const rowData = tableMeta?.tableData[tableMeta?.rowIndex][17];
    const parsedData = rowData ? JSON.parse(rowData) : {};
    const sortedPrevalidation = parsedData?.preValidationRuleEngineResult && parsedData?.preValidationRuleEngineResult.sort((a, b) => b.validationTs - a.validationTs);
    const shouldShowCheckCircle =(sortedPrevalidation?.[0]?.Auto_Approve || sortedPrevalidation?.[0]?.All_Rules_Passed);
    const lastUpdatedBy = tableMeta?.tableData[tableMeta?.rowIndex][23];
    return (
         <React.Fragment>
          {isAdjusted && lastUpdatedBy? (
              lastUpdatedBy.toLowerCase().includes('ai system') ? (
                <BuildIcon
                  size="medium"
                  data-testid={"build-icon"}
                  className={classes.iconStyle}
                  onClick={(event) => { warningHandle(event, tableMeta) }}
                />
              ) : (
                <PersonIcon
                  size="medium"
                  data-testid={"person-icon"}
                  className={classes.iconStyle}
                  onClick={(event) => { warningHandle(event, tableMeta) }}
                />
              )
            ) : 
         tableMeta?.tableData[tableMeta?.rowIndex][17] ? (
          shouldShowCheckCircle && invoiceStatus ? (
            <CheckCircle
              size="medium"
              className={classes.warningStyle}
              data-testid={"success-icon"}
              onClick={(event) => { warningHandle(event, tableMeta) }}
            />
          ) : (
            <Warning
              size="medium"
              className={classes.warningStyle}
              data-testid={"warning-icon"}
              onClick={(event) => { warningHandle(event, tableMeta) }}
            />
          )
        ) : <></> }
        {(tableMeta?.tableData[tableMeta?.rowIndex][7] &&
          tableMeta?.tableData[tableMeta?.rowIndex][9]) ? //check if unit & rate present to identify, if row is an invoice level edited row
          <ActionPopover
            actionItems={lineItemActionslist}
            onClickOption={onActionItemClick}
            tableMeta={tableMeta}
          /> : <></>
        }
      </React.Fragment>
    )
  }

  /**
   * Gets called when clicked on action item in datatable row
   */
  const onActionItemClick = (selectedId, tableMeta) => {
    const body = {
      lineItemType: tableMeta.tableData[tableMeta.rowIndex][16],
      lineItemDate: tableMeta.tableData[tableMeta.rowIndex][1],
      description: tableMeta.tableData[tableMeta.rowIndex][2],
      utbmsCode: tableMeta.tableData[tableMeta.rowIndex][3],
      activityCode: tableMeta.tableData[tableMeta.rowIndex][4],
      unit: tableMeta.tableData[tableMeta.rowIndex][7],
      rate: tableMeta.tableData[tableMeta.rowIndex][9],
      tkId: tableMeta.tableData[tableMeta.rowIndex][5],
      timekeeperUserId: tableMeta.tableData[tableMeta.rowIndex][21],
      timekeeperEmail: tableMeta.tableData[tableMeta.rowIndex][19],
      timekeeperName: tableMeta.tableData[tableMeta.rowIndex][20],
      adjustmentValue: tableMeta.tableData[tableMeta.rowIndex][11],
      discountValue:
        tableMeta.tableData[tableMeta.rowIndex][10] < 0
          ? Math.abs(tableMeta.tableData[tableMeta.rowIndex][10])
          : -tableMeta.tableData[tableMeta.rowIndex][10],
      parentId: tableMeta.tableData[tableMeta.rowIndex][18],
    };
    const filteredBody = filterPayload(body)
    postService(
      INVOICE_SERVICE,
      `/invoices/v1/${invoiceId}/sub-line-items`,
      filteredBody
    )
      .then((res) => {
        fetchLineItemDetails();
        addSnack({
          message: INVOICE_UPDATE_MESSAGE,
        });
      })
      .catch((error) => {
        addSnack({
          message: getErrorMessage(error)
        });
      });
  }

  const handleRowClick = (rowData, rowMeta) => {
    const parsedData = rowData?.[17] ? JSON.parse(rowData?.[17]) : {};
    const preValidationRuleEngineResult = parsedData?.preValidationRuleEngineResult;
    const sortedPrevalidation = preValidationRuleEngineResult && preValidationRuleEngineResult.sort((a, b) => b.validationTs - a.validationTs);
    history.push(`/invoice/${invoiceId}/lineItem/${rowData[15]}`, { fromMatter, currentMatterTab, isEditAllowed:sortedPrevalidation?.[0]?.isEditAllowed });
  }

  const renderLineItemDate=(value) => {
    return <Caption as="p">
      {displayLocalDate(value, MOMENT_DATE_FORMAT, "")}
    </Caption>
  }


  const renderRowHeader = (name) => {
    return (
      <Tooltip title={LINE_ITEM_ROW_DESCRIPTIONS?.[name]}>
        {name}
      </Tooltip>
    )
  }

  const LINEITEMS_COLUMNS = [
    {
      name: "lineItemNumber",
      label: "#",
      colKey: "lineItemNumber",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta, update) => (value? value : getSerialNumber(tableMeta))
      },
    },
    {
      name: "lineItemDate",
      label: "Date",
      colKey: "lineItemDate",
      options: {
        sort: true,
        customBodyRender: renderLineItemDate
      },
    },
    {
      name: "description",
      label: "Description",
      colKey: "description",
      options: {
        sort: true,
        setCellHeaderProps: () => ({ style: { minWidth: "230px", padding: "5px 16px" } }),
        setCellProps: () => ({ style: { minWidth: "230px", padding: "5px 16px" } }),
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-description-${tableMeta.rowIndex}`,value),
      },
    },
    {
      name: "utbmsCode",
      label: "UTBMS",
      colKey: "utbmsCode",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-utbmsCode-${tableMeta.rowIndex}`,value),
      },
    },
    {
      name: "activityCode",
      label: "ACT",
      colKey: "activityCode",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-activityCode-${tableMeta.rowIndex}`,value),
      },
    },
    {
      name: "tkId",
      label: "TK ID",
      colKey: "tkId",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const tkFullName = tableMeta?.rowData?.[20];
          return `${tkFullName ? tkFullName: ' '} ${value ? '( ' + value + ' )': ' '}`; // displaying full name of Tk along with id
        }
      },
    },
    {
      name: "initialUnit",
      label: renderRowHeader("# Initial Units"),
      colKey: "initialUnit",
      options: {
        sort: true,
        customBodyRender: (value) => renderTernary(value, value, 0),
      },
    },
    {
      name: "unit",
      label:  renderRowHeader("# Units"),
      colKey: "unit",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-unit-${tableMeta.rowIndex}`,value),
      },
    },
    {
      name: "initialRate",
      label: renderRowHeader("$ Initial Rate"),
      colKey: "initialRate",
      options: {
        sort: true,
        customBodyRender: (value) => renderTernary(value, `$${amountFormat(value)}`, 0),
      },
    },
    {
      name: "rate",
      label: renderRowHeader("$ Rate"),
      colKey: "rate",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-rate-${tableMeta.rowIndex}`,`$${amountFormat(value)}`),
      },
    },
    {
      name: "discountValue",
      label: renderRowHeader("$ Discount"),
      colKey: "discountValue",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-discountValue-${tableMeta.rowIndex}`,`$${amountFormat(value)}`),
      },
    },
    {
      name: "adjustmentValue",
      label: renderRowHeader("$ Adjustment"),
      colKey: "adjustmentValue",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-adjustmentValue-${tableMeta.rowIndex}`, `$${amountFormat(value)}`),
      },
    },
    {
      name: "totalAdjustment",
      label: renderRowHeader("$ Total Adjustment"),
      colKey: "totalAdjustment",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const total = (tableMeta?.rowData?.[22] ? tableMeta?.rowData?.[22] : 0) + (tableMeta?.rowData?.[11] ? tableMeta?.rowData?.[11] : 0);
           return TableCellDisplay(`table-row-adjustmentValue-${tableMeta.rowIndex}`, `$${amountFormat(total)}`)
        }
      },
    },
    {
      name: "netAmount",
      label: renderRowHeader("$ Net Amount"),
      colKey: "netAmount",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => {
          return TableCellDisplay(`table-row-netAmount-${tableMeta.rowIndex}`,`$${amountFormat(value)}`)
        },
      },
    },
    {
      name: "actions",
      label: "Actions",
      colKey: "actions",
      options: {
        sort: false,
        display: (invoiceStatus?.toLowerCase() ==="appealed" || invoiceStatus?.toLowerCase() === LABEL_DRAFT),
        setCellHeaderProps: () => ({ style: { color: "#2E2F32", fontWeight: "bold" } }),
        customBodyRender: actionsBodyRender,
      },
    },
    {
      name: "id",
      label: "id",
      colKey: "id",
      options: {
        display: false,
      },
    },
    {
      name: "lineItemType",
      label: "Line Item Type",
      colKey: "lineItemType",
      options: {
        display: false,
      },
    },
    {
      name: "ruleResult",
      label: "Rule Result",
      colKey: "ruleResult",
      options: {
        display: false,
      },
    },
    {
      name: "parentId",
      label: "parentId",
      colKey: "parentId",
      options: {
        display: false,
      },
    },
    {
      name: "timekeeperEmail",
      label: "timekeeperEmail",
      colKey: "timekeeperEmail",
      options: {
        display: false,
      },
    },
    {
      name: "timekeeperName",
      label: "timekeeperName",
      colKey: "timekeeperName",
      options: {
        display: false,
      },
    },
    {
      name: "timekeeperUserId",
      label: "timekeeperUserId",
      colKey: "timekeeperUserId",
      options: {
        display: false,
      },
    },
    {
      name: "adjustmentDueToUnitRate",
      label: "adjustmentDueToUnitRate",
      colKey: "adjustmentDueToUnitRate",
      options: {
        display: false,
      },
    },
    {
      name: "lastUpdatedBy",
      label: "lastUpdatedBy",
      colKey: "lastUpdatedBy",
      options: {
        display: false,
      },
    },
    {
      name:"reason",
      colKey: "adjustmentReason",
      options: {
        display: false
      }
    }
  ];

  /**
   * Function to call api on pagination action
   * @param {number} rowsPerPage
   * @param {number} page
   */
  const handleServerSidePaginationAdjusted = ({ rowsPerPage, page }) => {
    dispatch(setAdjustedPaginationForLineItems({
      currentPage: page,
      rowsPerPage: rowsPerPage,
      tabName: isCurrent,
      adjustedFeeCount: adjustedLineItemsPaginationDetail?.adjustedFeeCount,
      adjustedExpenseCount: adjustedLineItemsPaginationDetail?.adjustedExpenseCount
    }));
    setRowsPerPageLineItemsAdjusted(rowsPerPage);
    fetchLineItemDetails(`&limit=${rowsPerPage}&offset=${rowsPerPage * page}`, sortQueryAdjusted);
    dispatch(setAdjustedSelectLineItems({ids: [], idNumberMap: []}));
  };

  const handleServerSidePaginationNonAdjusted = ({ rowsPerPage, page }) => {
    dispatch(setNonAdjustedPaginationForLineItems({
      currentPage: page,
      rowsPerPage: rowsPerPage,
      tabName: isCurrent,
      nonAdjustedFeeCount: nonAdjustedLineItemsPaginationDetail?.nonAdjustedFeeCount,
      nonAdjustedExpenseCount: nonAdjustedLineItemsPaginationDetail?.nonAdjustedExpenseCount
    }));
    setRowsPerPageLineItemsNonAdjusted(rowsPerPage);
    fetchLineItemDetails(`&limit=${rowsPerPage}&offset=${rowsPerPage * page}`, sortQueryNonAdjusted);
    dispatch(setNonAdjustedSelectLineItems({ids: [], idNumberMap: []}));
  };

  useEffect(()=>{
    if (nonAdjustedSelectLineItems.length + adjustedSelectLineItems.length === 0) {
      resetSelectedRows();
    }
  },[nonAdjustedSelectLineItems, adjustedSelectLineItems])

  const resetSelectedRows = () => {
    setSelectRowsData([]);
  }

  const handleRowSelectionChange = (currentSelect, allSelected, selectRowsData) => {
    const bData = lineItemsData?.lineitems;
    const result = allSelected.map(item => bData && bData[item.index]);
    setSelectRowsData(selectRowsData);
    const lineItems=result;
    if (isAdjusted) {
      dispatch(setAdjustedSelectLineItems({ids: lineItems.map((item)=>item.id), idNumberMap: lineItems.map((item)=>({[item.id]:item?.lineItemNumber ? item.lineItemNumber.toString() : null }))}));
    } else {
      dispatch(setNonAdjustedSelectLineItems({ids: lineItems.map((item)=>item.id), idNumberMap: lineItems.map((item)=>({[item.id]:item?.lineItemNumber ? item?.lineItemNumber.toString() : null }))}));
    }
  }

  useEffect(()=>{
    return ()=>{
      dispatch(setAdjustedSelectLineItems({ids: [], idNumberMap: []}));
      dispatch(setNonAdjustedSelectLineItems({ids: [], idNumberMap: []}));
    }
  },[])

  /**
  * Function to call api on sort action (server side)
  * @param {number} rowsPerPage
  * @param {number} page
  */
  const handleServerSideSortAdjusted = ({ name, direction }) => {
    setSortQueryAdjusted(`&order=${name} ${direction}`);
    fetchLineItemDetails(`&limit=${adjustedLineItemsPaginationDetail?.rowsPerPage}
      &offset=${adjustedLineItemsPaginationDetail?.rowsPerPage * adjustedLineItemsPaginationDetail?.currentPage}`,
      `&order=${name} ${direction}`
    );
  };

  const handleServerSideSortNonAdjusted = ({ name, direction }) => {
    setSortQueryNonAdjusted(`&order=${name} ${direction}`);
    fetchLineItemDetails(`&limit=${nonAdjustedLineItemsPaginationDetail?.rowsPerPage}
      &offset=${nonAdjustedLineItemsPaginationDetail?.rowsPerPage * nonAdjustedLineItemsPaginationDetail?.currentPage}`,
      `&order=${name} ${direction}`
    );
  };

  const lineItemFilterConfigs = [
    {
      colKey: "adjustmentReason",
      type: "masterDataAutocomplete",
      dataType: "invoiceAdjustmentReason",
      label: "Select Invoice Adjustment Reason",
    }
  ]

  const handleServerSideFilter = (filterQuery) => {
    setFilters(filterQuery);
  };

  const lineItemsTableCustomOptionsAdjusted = {
    page: adjustedLineItemsPaginationDetail?.currentPage,
    rowsPerPage: adjustedLineItemsPaginationDetail?.rowsPerPage ?? rowsPerPageLineItemsAdjusted,
    rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS_LINE_ITEMS,
    serverSide: ENABLE_SERVER_SIDE_FEATURES_LINE_ITEMS,
    onServerSidePagination: handleServerSidePaginationAdjusted,
    onServerSideSort: handleServerSideSortAdjusted,
    totalCount: lineItemsData?.count,
    customHeaderToolTip: true,
    filterConfigs: lineItemFilterConfigs,
    persistFilter : true,
    filterComponentName: "lineItemFilter",
    onServerSideFilter: handleServerSideFilter,
  };

  const lineItemsTableCustomOptionsNonAdjusted = {
    page: nonAdjustedLineItemsPaginationDetail?.currentPage,
    rowsPerPage: nonAdjustedLineItemsPaginationDetail?.rowsPerPage ?? rowsPerPageLineItemsNonAdjusted,
    rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS_LINE_ITEMS,
    serverSide: ENABLE_SERVER_SIDE_FEATURES_LINE_ITEMS,
    onServerSidePagination: handleServerSidePaginationNonAdjusted,
    onServerSideSort: handleServerSideSortNonAdjusted,
    totalCount: lineItemsData?.count,
    customHeaderToolTip: true
  };

  const [invoiceLineItemsTableColumns, setInvoiceLineItemsTableColumns] = useState(LINEITEMS_COLUMNS)
  const accessibility = useSelector((state) => state?.accessibility?.applicationAccess?.financial?.invoice?.details?.tabs?.lineItems);
  const lineItemActionslist = [{
    "actionId": 0,
    "label": "Set Net Amount to Zero",
    "isAboveDivider": true,
    "showAction": accessibility?.edit && (invoiceStatus?.toLowerCase() === "appealed"),
  }];

  /**
   * Function to fetch invoice details of specific invoice id
   */
  const fetchLineItemDetails = (paginationQuery = "", sortQuery="&order=lineItemDate asc") => {
    setLineItemsLoading(true);
    const filterCondition = `${defaultFilterCondition}${filters? `+${filters}` : ""}`;
    getService(INVOICE_SERVICE, `/search/line-items/v1/?filter=(${filterCondition})& ${paginationQuery} ${sortQuery}`)
      .then((res) => {
        const lineItems = res?.data;
        if (lineItemType === "Fees") {
          if (isAdjusted) {
            dispatch(setAdjustedFeeLineItems(lineItems))
          } else {
            dispatch(setNonAdjustedFeeLineItems(lineItems))
          }
        } else {
          if (isAdjusted) {
            dispatch(setAdjustedExpenseLineItems(lineItems))
          } else {
            dispatch(setNonAdjustedExpenseLineItems(lineItems))
          }
        }
        setLineItemsLoading(false);
      })
      .catch((error) => {
        setLineItemsLoading(false);
        addSnack({
          message: getErrorMessage(error)
        });
      });
  };

  useEffect(() => {
    let offsetQuery = "";
    if (ENABLE_SERVER_SIDE_FEATURES_LINE_ITEMS) {
      let nonAdjustedCountCheck;
      let adjustedCountCheck;
      if(nonAdjustedLineItemsPaginationDetail?.tabName !== '' && nonAdjustedLineItemsPaginationDetail?.tabName === 'Fees'){
        if(nonAdjustedLineItemsPaginationDetail?.nonAdjustedFeeCount !== undefined || nonAdjustedLineItemsPaginationDetail?.nonAdjustedFeeCount !== 0){
          nonAdjustedCountCheck = (nonAdjustedLineItemsPaginationDetail?.nonAdjustedFeeCount <= nonAdjustedLineItemsPaginationDetail?.rowsPerPage) ? 0 : (nonAdjustedLineItemsPaginationDetail?.rowsPerPage * nonAdjustedLineItemsPaginationDetail?.currentPage);
        }        
      }else if(nonAdjustedLineItemsPaginationDetail?.tabName !== '' && nonAdjustedLineItemsPaginationDetail?.tabName === 'Expenses'){
        if(nonAdjustedLineItemsPaginationDetail?.nonAdjustedExpenseCount !== undefined || nonAdjustedLineItemsPaginationDetail?.nonAdjustedExpenseCount !== 0){
          nonAdjustedCountCheck = (nonAdjustedLineItemsPaginationDetail?.nonAdjustedExpenseCount <= nonAdjustedLineItemsPaginationDetail?.rowsPerPage) ? 0 : (nonAdjustedLineItemsPaginationDetail?.rowsPerPage * nonAdjustedLineItemsPaginationDetail?.currentPage);
        }
      }
      if(adjustedLineItemsPaginationDetail?.tabName !== '' && adjustedLineItemsPaginationDetail?.tabName === 'Fees'){
        if(adjustedLineItemsPaginationDetail?.adjustedFeeCount !== undefined || adjustedLineItemsPaginationDetail?.adjustedFeeCount !== 0){
          adjustedCountCheck = (adjustedLineItemsPaginationDetail?.adjustedFeeCount <= adjustedLineItemsPaginationDetail?.rowsPerPage) ? 0 : (adjustedLineItemsPaginationDetail?.rowsPerPage * adjustedLineItemsPaginationDetail?.currentPage);
        }        
      }else if(adjustedLineItemsPaginationDetail?.tabName !== '' && adjustedLineItemsPaginationDetail?.tabName === 'Expenses'){
        if(adjustedLineItemsPaginationDetail?.adjustedExpenseCount !== undefined || adjustedLineItemsPaginationDetail?.adjustedExpenseCount !== 0){
          adjustedCountCheck = (adjustedLineItemsPaginationDetail?.adjustedExpenseCount <= adjustedLineItemsPaginationDetail?.rowsPerPage) ? 0 : (adjustedLineItemsPaginationDetail?.rowsPerPage * adjustedLineItemsPaginationDetail?.currentPage);
        }
      }
      
      const tabCurrPage = (isCurrent !== nonAdjustedLineItemsPaginationDetail?.tabName) ? 0: nonAdjustedCountCheck;
      const tabAdustedCurrPage = (isCurrent !== adjustedLineItemsPaginationDetail?.tabName) ? 0: adjustedCountCheck;
      const rows = isAdjusted ? rowsPerPageLineItemsAdjusted : rowsPerPageLineItemsNonAdjusted;
      const currPage = isAdjusted ? tabAdustedCurrPage : tabCurrPage;
      offsetQuery = `&limit=${rows}&offset=${currPage}`;
    }
    //Reset line items data
    if (lineItemType === "Fees") {
      if (isAdjusted) {
        dispatch(setAdjustedFeeLineItems({}))
      } else {
        dispatch(setNonAdjustedFeeLineItems({}))
      }
    } else {
      if (isAdjusted) {
        dispatch(setAdjustedExpenseLineItems({}))
      } else {
        dispatch(setNonAdjustedExpenseLineItems({}))
      }
    }
    if (!parentLoading) {
      fetchLineItemDetails(offsetQuery);
    }
  }, [isAdjusted, lineItemType, parentLoading, filters])

  useEffect(()=>{
    if(nonAdjustedFeeLineItems?.count !== 0){
      dispatch(setNonAdjustedPaginationForLineItems({
        currentPage: nonAdjustedLineItemsPaginationDetail?.currentPage,
        rowsPerPage: nonAdjustedLineItemsPaginationDetail?.rowsPerPage,
        tabName: nonAdjustedLineItemsPaginationDetail?.tabName,
        nonAdjustedFeeCount: nonAdjustedFeeLineItems?.count,
        nonAdjustedExpenseCount: nonAdjustedLineItemsPaginationDetail?.nonAdjustedExpenseCount
      }))
    }
    if(nonAdjustedExpenseLineItems?.count !== 0){
      dispatch(setNonAdjustedPaginationForLineItems({
        currentPage: nonAdjustedLineItemsPaginationDetail?.currentPage,
        rowsPerPage: nonAdjustedLineItemsPaginationDetail?.rowsPerPage,
        tabName: nonAdjustedLineItemsPaginationDetail?.tabName,
        nonAdjustedFeeCount: nonAdjustedLineItemsPaginationDetail?.nonAdjustedFeeCount,
        nonAdjustedExpenseCount: nonAdjustedExpenseLineItems?.count
      }))
    }
    if(adjustedFeeLineItems?.count !== 0){
      dispatch(setAdjustedPaginationForLineItems({
        currentPage: adjustedLineItemsPaginationDetail?.currentPage,
        rowsPerPage: adjustedLineItemsPaginationDetail?.rowsPerPage,
        tabName: adjustedLineItemsPaginationDetail?.tabName,
        adjustedFeeCount: adjustedFeeLineItems?.count,
        adjustedExpenseCount: adjustedLineItemsPaginationDetail?.adjustedExpenseCount
      }))
    }
    if(adjustedExpenseLineItems?.count !== 0){
      dispatch(setAdjustedPaginationForLineItems({
        currentPage: adjustedLineItemsPaginationDetail?.currentPage,
        rowsPerPage: adjustedLineItemsPaginationDetail?.rowsPerPage,
        tabName: adjustedLineItemsPaginationDetail?.tabName,
        adjustedFeeCount: adjustedLineItemsPaginationDetail?.adjustedFeeCount,
        adjustedExpenseCount: adjustedExpenseLineItems?.count
      }))
    }
  },[nonAdjustedFeeLineItems?.count, nonAdjustedExpenseLineItems?.count, adjustedFeeLineItems?.count, adjustedExpenseLineItems?.count])


  useEffect(() => {
    if(isAdjusted) {
      setSortQueryAdjusted(defaultSortQuery)
      dispatch(setAdjustedPaginationForLineItems({
        currentPage: adjustedLineItemsPaginationDetail?.currentPage,
        rowsPerPage: adjustedLineItemsPaginationDetail?.rowsPerPage,
        tabName: isCurrent,
        adjustedFeeCount: adjustedFeeLineItems?.count,
        adjustedExpenseCount: adjustedExpenseLineItems?.count
      }))
    } else {
      setSortQueryNonAdjusted(defaultSortQuery)
      dispatch(setNonAdjustedPaginationForLineItems({
        currentPage:  nonAdjustedLineItemsPaginationDetail?.currentPage,
        rowsPerPage:  nonAdjustedLineItemsPaginationDetail?.rowsPerPage,
        tabName: isCurrent,
        nonAdjustedFeeCount: nonAdjustedFeeLineItems?.count,
        nonAdjustedExpenseCount: nonAdjustedExpenseLineItems?.count
      }))
    }
  },[lineItemType])
  const shouldShowFilter = STATUSES_FOR_FILTER_LINE_ITEMS_ADJUSTMENT.includes(invoiceStatus);
  return (
    <>
      <MuiDataTable
        data={lineItemsData?.lineitems}
        selectableRowsType={FeatureValueToggle(FEATURES.BULK_LINE_ITEM_UPDATE, true, false) ? "multiple" : "none"}
        selectedRows={selectRowsData}
        onRowSelection={handleRowSelectionChange}
        columns={invoiceLineItemsTableColumns}
        customOptions={isAdjusted ? lineItemsTableCustomOptionsAdjusted : lineItemsTableCustomOptionsNonAdjusted}
        setTableColumns={setInvoiceLineItemsTableColumns}
        disableSearch={true}
        disableFilter={false}
        disablePagination={false}
        disableExport={true}
        hideAddNewButton={true}
        customClassName={`lineItemsTable customMuiClass ${shouldShowFilter && isAdjusted ? '' : 'hideFilter'}`}
        loading={lineItemsLoading || parentLoading}
        onRowClick={handleRowClick}
        resetSelectedRows={() => resetSelectedRows()}
        isRowSelectable = {(params) => {
          return !(lineItemsData?.lineitems[params]?.description === "Invoice Level Adjustment/Discount Applied" && !lineItemsData?.lineitems[params]?.unit && !lineItemsData?.lineitems[params]?.rate)
      }}
        hideFilter={false}
      />
      {isOpen && <WarningPanel
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title={LINE_ITEM_MESSAGES}
        alertMessage={alertMessage}
        description={lineItemDescription}
        variant="info"
      >
        <LineItemRuleResultPopOver lineItemRuleResults={lineItemRuleResults} />
      </WarningPanel>
      }
      </>
  )
};

  export default React.memo(LineItemDatatable);